import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../core/store';
import { filter, take } from 'rxjs/operators';
import * as subGroupActions from '../../../../core/store/sub-groups/sub-group.actions';
import * as layoutActions from '../../../../core/store/layout/layout.actions';
import { Attachment, Group, SubGroup } from '../../../../core/store/models';
import { rootSelectors } from '../../../../core/store/selectors';
import { ActionStatus, SavingMessage, Severity } from '../../../../core/store/types';
import { ModalTypes } from '../../../constants/modal-types.enum';

export interface SubGroupModalData {
    selectedGroup: Group;
    subGroup: SubGroup;
    groupList: Group[];
    type: ModalTypes;
    subGroupType: string;
}

@Component({
    templateUrl: './sub-group-modal.component.html',
    styleUrls: ['../../../../sass/modal.scss', './sub-group-modal.component.scss'],
    standalone: false
})
export class SubGroupModalComponent implements OnInit {
    subGroup: SubGroup;
    savingMessage: SavingMessage[] = [];
    isDisabled = true;
    type: ModalTypes;
    selectedGroup: number;
    subGroupType: string;
    groupList: Group[];

    accept = Attachment.ALLOWED_TYPES;
    attachments: File[] = [];

    @ViewChild('attachmentUpload', { static: false }) attachmentUpload;
    ModalTypes = ModalTypes;
    constructor(@Inject(MAT_DIALOG_DATA) private data: SubGroupModalData, public dialog: MatDialog, private dialogRef: MatDialogRef<SubGroupModalComponent>, private store: Store<rootSelectors.State>) { }

    ngOnInit() {
        this.subGroup = new SubGroup(this.data.subGroup);
        this.type = this.data.type;
        this.groupList = this.data.groupList;
        this.subGroupType = this.data.subGroupType;
        this.selectedGroup = (this.type === ModalTypes.Edit) ? this.subGroup.group_id : this.data.selectedGroup.id;
    }

    addAttachment($event) {
        this.attachments = [...this.attachments, ...$event.files];
        this.attachmentUpload.clear();
    }

    removeAttachment(attachment: File) {
        this.attachments = this.attachments.filter(att => att !== attachment);
    }

    save(groupForm: NgForm) {
        this.savingMessage = [{ severity: Severity.Info, summary: 'Saving...' }];
        this.isDisabled = false;
        const subGroup = new SubGroup(this.subGroup);
        subGroup.name = groupForm.value.name;
        subGroup.description = groupForm.value.description;
        subGroup.group_id = this.selectedGroup;

        if (this.type === ModalTypes.Edit) {
            this.store.dispatch(new subGroupActions.UpdateAction(subGroup));
            this.store.select(rootSelectors.getSubGroupsSaving).pipe(filter(s => s !== ActionStatus.Loading), take(1)).subscribe(status => {
                if (status === ActionStatus.Complete) {
                    this.store.dispatch(new layoutActions.InfoAction({
                        message: `${subGroup.name} saved successfully!`
                    }));
                }
                this.dialogRef.close(true);
            });
        } else {
            subGroup.group_id = this.selectedGroup;
            const types = this.attachments.map(att => att.type);
            this.store.dispatch(new subGroupActions.ResetAction())
            this.store.dispatch(new subGroupActions.AddAction({ subGroup: subGroup, attachments: this.attachments, types: types }));

            this.store.select(fromRoot.getSubGroupsAdding).pipe(
                filter(saving => {
                    return saving === ActionStatus.Complete
                }),
                take(1),
            ).subscribe(() => {
                this.dialogRef.close(true);
            });
        }
    }
}
